import api from './api';
import { Alert, AlertCounts, AlertType, AlertStatus } from '@/types';

export interface AlertFilters {
  alert_type?: AlertType;
  alert_status?: AlertStatus;
  only_unread?: boolean;
  skip?: number;
  limit?: number;
}

export const alertsService = {
  async getAlerts(filters?: AlertFilters): Promise<Alert[]> {
    const response = await api.get<Alert[]>('/alerts', { params: filters });
    return response.data;
  },

  async getAlertCounts(): Promise<AlertCounts> {
    const response = await api.get<AlertCounts>('/alerts/counts');
    return response.data;
  },

  async getAlert(id: number): Promise<Alert> {
    const response = await api.get<Alert>(`/alerts/${id}`);
    return response.data;
  },

  async updateAlert(id: number, data: { status?: AlertStatus; is_read?: boolean }): Promise<Alert> {
    const response = await api.patch<Alert>(`/alerts/${id}`, data);
    return response.data;
  },

  async dismissAlert(id: number): Promise<Alert> {
    const response = await api.post<Alert>(`/alerts/${id}/dismiss`);
    return response.data;
  },

  async markAllAsRead(alertType?: AlertType): Promise<{ message: string; count: number }> {
    const response = await api.post('/alerts/mark-all-read', null, {
      params: { alert_type: alertType },
    });
    return response.data;
  },

  async generateAlerts(): Promise<{ generated: { low_stock: number; expiration: number; total: number } }> {
    const response = await api.post('/alerts/generate');
    return response.data;
  },
};
